<div
  class="mobile-menu"
  [ngStyle]="menuStyles"
  test-target="app-header-mobile-menu"
>
  <ng-container *ngIf="isSuggestionsListVisible$ | async; else categoriesTemplate">
    <app-suggestions-list
      [isMobile]="true"
    ></app-suggestions-list>
  </ng-container>

   <app-generic-header-topline-links *ngIf="!isHideTopLineMenu">
   </app-generic-header-topline-links>
</div>

<ng-template #categoriesTemplate>
  <app-mobile-categories
    [categories]="categories$ | async"
    (menuClosed)="closeMenu()"
    (hideTopLineMenu)="hideTopLineMenu($event)"
  ></app-mobile-categories>
</ng-template>
